import { authFetch } from "./authFetch";
import { refreshProxyCookie } from "./authService";
import store from "../redux/store";

const BASE_URL = window.env.API_BASE_URL;

export const getAllHosts = async (gatewayId, isOwner) => {
  try {
    const response = await authFetch(`${BASE_URL}/Host/GetAllByGatewayId/${gatewayId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      return null;
    }

    const hosts = await response.json();

    const updatedHosts = hosts.map(host => ({
      ...host,
      isOwner: isOwner,
    }));

    return updatedHosts;
  } catch (error) {
    return null;
  }
};

export const addNewHost = async (
  name,
  reverseProxyUrl,
  url,
  reverseProxyLocation,
  gatewayId,
  panelType,
  phosUsername,
  phosPassword,
) => {
  try {
    const body = {
      name: name,
      reverseProxyUrl,
      url: url,
      gatewayId: gatewayId,
      locationName: reverseProxyLocation,
      panelType,
    };
    if (panelType === "Phos") {
      body.hostAuthenticationDataDto = {
        username: phosUsername,
        password: phosPassword,
      };
    }
    const response = await authFetch(`${BASE_URL}/Host/Add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "_unknownError");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteHostById = async (id, gatewayId) => {
  try {
    const response = await authFetch(`${BASE_URL}/Host/DeleteById/${id}/${gatewayId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const text = await response.text();
    if (!response.ok) {
      throw new Error(text || "_unknownError");
    }

    return text;
  } catch (error) {
    throw error;
  }
};

export const updateHostById = async (id, gatewayId, name, username, password) => {
  const body = { name, username, password };
  const response = await authFetch(`${BASE_URL}/Host/UpdateById/${id}/${gatewayId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "_unknownError");
  }

  return await response.json();
};

export const getHostHTMLContent = async endpoint => {
  try {
    const { refreshToken } = store.getState().auth.user;

    if (!refreshToken) {
      console.warn("No refresh token found in auth state.");
      return null;
    }

    await refreshProxyCookie(refreshToken);
  } catch (error) {
    console.error("Failed to refresh proxy cookie:", error);
    return null;
  }

  try {
    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method: "GET",
      credentials: "include",
    });

    if (!response.ok) {
      return null;
    }

    return await response.text();
  } catch (error) {
    return null;
  }
};

export const tryAgainHostById = async (id, gatewayId) => {
  const response = await authFetch(`${BASE_URL}/Host/Activate/${id}/${gatewayId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    throw new Error(`Failed try again in Phos with ID ${id}`);
  }
  return response;
};
